module.exports = "/static/assets/8628ba88ec9dc2777d0e37646513fbb6.png";